import { useCallback } from 'react'

type UseScrollToType = (elementId: string, options?: ScrollOptions) => void

export const useScrollTo = (): UseScrollToType => {
  const scrollTo: UseScrollToType = useCallback((elementId: string, options: ScrollOptions = {}) => {
    const element: HTMLElement | null = document.getElementById(elementId)

    if (element) {
      const defaultOptions: ScrollOptions = {
        behavior: 'smooth',
      }

      element.scrollIntoView({
        ...defaultOptions,
        ...options,
      })
    }
  }, [])

  return scrollTo
}
